import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ currentChat: 'getSelectedChat' }),
    currentContact() {
      return this.$store.getters['contacts/getContact'](
        this.currentChat.meta?.sender?.id
      );
    },
  },
};
